import React from "react";

import "./filter.scss";

const FilterIcon = ({ open, active, disabled }) => {
  const getClassName = () => {
    const styleClass = "parent-filter-icon";
    const classUser =
      open && active
        ? `${styleClass}-open ${styleClass}-open--active`
        : open
        ? `${styleClass}-open`
        : active
        ? `${styleClass}--active`
        : disabled
        ? `${styleClass}--disable`
        : styleClass;
    return classUser;
  };
  return (
    <svg id="Filter" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className={getClassName()}>
      <g id="Group_10900" data-name="Group 10900">
        <path id="Path_9297" data-name="Path 9297" className="filtercls-1" d="M0,0H30m0,30H0" />
        <g id="Path_9298" data-name="Path 9298" className="filtercls-2">
          <path className="filtercls-3" d="M24,8H8l6.46,8.017V24l3.08-2V16.017Z" />
          <path
            className="filtercls-4"
            d="M 10.09003448486328 9 L 15.45984077453613 15.66402053833008 L 15.45984077453613 22.15841674804688 L 16.5401611328125 21.45698165893555 L 16.5401611328125 15.66402053833008 L 21.90996551513672 9 L 10.09003448486328 9 M 8 8 L 24 8 L 17.5401611328125 16.01678085327148 L 17.5401611328125 22 L 14.45984077453613 24 L 14.45984077453613 16.01678085327148 L 8 8 Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default FilterIcon;
